
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const notificationService = {
    getNotifyList,
    getNotifyDetails,
    getCustomerList,
    sendNotificationMessage,
   notificationFilter,
   notificationView,
   searchByDate,
   getSurvey,
   processSurvey,
   getSurveyList,
   submitIVRHistory,
   historyFromDelgro,
   getIVRDetails,
   ivrScheduleList,
   deleteSchedule,
   getSurveyItemDetails,
   genenralNotificationList
};

async function  getNotifyList() {
    return  apiClient.get(`/notification/notify-main-list`, authHeader());
}



async function  historyFromDelgro(formData) {
    return  apiClient.post(`/notification/history-from-delgro`, formData, authHeader());
}


async function  ivrScheduleList() {
    return  apiClient.get(`/notification/ivr-schedule-list`, authHeader());
}


async function  deleteSchedule(key) {
    return  apiClient.delete(`/notification/ivr-schedule/${key}`, authHeader());
}


async function  submitIVRHistory(formData) {
    return  apiClient.post(`/notification/submit-ivr-history`, formData, authHeader());
}

async function  getSurvey() {
    return  apiClient.get(`/notification/get-survey`, authHeader());
}

async function  getSurveyList(query) {
    return  apiClient.get(`/notification/get-survey-list?${query}`, authHeader());
}

async function  getSurveyItemDetails(id, query) {
    return  apiClient.get(`/notification/get-survey-item-details/${id}?${query}`, authHeader());
}

async function  processSurvey(data) {
    return  apiClient.post(`/notification/process-survey`, data, authHeader());
}

async function  getNotifyDetails(id) {
    return  apiClient.get(`/notification/notify-details/${id}`, authHeader());
}

async function  getIVRDetails(id) {
    return  apiClient.get(`/notification/ivr-details/${id}`, authHeader());
}


async function  getCustomerList() {
    return  apiClient.get(`/notification/notification-customers`, authHeader());
}


async function  sendNotificationMessage(bodyData) {
    return  apiClient.post(`/notification/send-notification`, bodyData , authHeader());
}


async function  notificationFilter(form) {
    return  apiClient.post(`/notification/notification-filter`, form, authHeader());
}


async function  notificationView() {
    return  apiClient.get(`/notification/notification-view`, authHeader());
}


async function  searchByDate(data) {
    return  apiClient.post(`/notification/search-by-date`, data, authHeader());
}



async function  genenralNotificationList() {
    return  apiClient.get(`/notification/general-notifications`, authHeader());
}













